import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { AppConfig } from './app.config';

@Injectable({
  providedIn: 'root'
})
export class HomeService {

  constructor(public http: HttpClient, public AppConfig: AppConfig) { }

    addCRMLead(reqData: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'token': '6669ac7eeb6f363a778463e0',
        "orgid": reqData.orgId,
        "uid":  reqData.uid,
      })
    };

    // return this.http.post('https://crm-api-prod.iquanta.in/api/v1/org/leads/details/single/create', reqData, httpOptions)
    //   .pipe(map((response: any) => response));
      return this.http.post('https://crm-api-prod.iquanta.in/api/v1/org/leads/details/single/v2/create', reqData, httpOptions)
      .pipe(map((response: any) => response));
  }

   callbackLead(reqData: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'token': '6669ac7eeb6f363a778463e0',
        "orgid": "66dec57ce200bc89284602d6",
        "uid": '66dec57ce200bc89284602d6',
      })
    };

      return this.http.post('https://crm-api-prod.iquanta.in/api/v1/org/leads/details/single/v2/create/backup', reqData, httpOptions)
      .pipe(map((response: any) => response));
  }

    addLeadSquared(reqData: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };

    return this.http.post('https://services.in8.nopaperforms.com/webhooks/v1/leadCapture/5802', reqData, httpOptions)
      .pipe(map((response: any) => response));
  }

   updateLeadSquared(reqData: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    };

    return this.http.post('https://services.in8.nopaperforms.com/webhooks/v1/leadCapture/5802', reqData, httpOptions)
      .pipe(map((response: any) => response));
  }

    getProfile(token: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Token ' + token
      })
    };

    return this.http.get(this.AppConfig.LOGIN_ENDPOINT + 'user_get', httpOptions)
      .pipe(map((response: any) => response));
  }

   addCallClickData(reqData: any) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'token': '6669ac7eeb6f363a778463e0',
          "orgid": "66dec57ce200bc89284602d6",
          "uid": '66dec57ce200bc89284602d6',
        })
      };
  
      return this.http.post('https://crm-api-prod.iquanta.in/api/v1/org/product/entity/counter/update', reqData, httpOptions)
        .pipe(map((response: any) => response));
    }

}